import { useState, useEffect } from 'react'
import {
  useMediaQuery,
  Grid,
  makeStyles,
  Container,
  useTheme,
  Hidden,
} from '@material-ui/core'
import Layout from '../components/common/Layout'
import CountUpSp from '../components/ui/CountUpSp'
import ButtonSp from '../components/ui/ButtonSp'
import Couriers from '../components/common/Couriers'
import CarouselSp2 from '../components/ui/CarouselSp2'
import LinesEllipsis from 'react-lines-ellipsis'
import Axios from 'axios'
import getConfig from 'next/config'
import LazyLoad from 'react-lazyload'
import LazyloadPlaceholder from '../components/ui/LazyloadPlaceholder'

import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCookie, setCookie } from '../utils/cookies'
import dayjs from 'dayjs'
import AboutNew from '../components/pages-new/AboutNew'

const { publicRuntimeConfig } = getConfig()

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.homeStyle.root,
  },
  title: {
    ...theme.homeStyle.title,
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      marginBottom: 40,
    },
  },
  heroImage: {
    background:
      'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url("/static/img/about-us/header-about-us.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: theme.homeStyle.heroImageHeightDesktop,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5),
    },
    [theme.breakpoints.down('xs')]: {
      background: 'url("/static/img/about-us/header-about-us-mobile.jpg")',
      backgroundSize: 'cover',
      height: 350,
      padding: theme.spacing(1),
    },
  },
  heroContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '80%',
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
    },
  },
  heroText: {
    textAlign: 'left',
    '& h1': {
      ...theme.homeStyle.heroTitle,
      margin: 0,
    },
    '& h2': {
      fontWeight: 400,
      fontSize: 32,
      color: 'white',
      margin: 0,
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      '& h1': {
        margin: `${theme.spacing(1)}px 0`,
        fontSize: 52,
        color: 'white',
      },
      '& h2': {
        margin: `${theme.spacing(1)}px 0`,
        fontSize: 38,
        color: 'white',
      },
    },
    [theme.breakpoints.down('xs')]: {
      '& h1': {
        color: '#404041',
        margin: `${theme.spacing(2)}px 0`,
        fontSize: '24px',
      },
      '& h2': {
        color: '#404041',
        fontSize: 24,
      },
    },
  },
  shippedAmount: {
    display: 'flex',
    flexDirection: 'row',
  },
  shippedAmountText: {
    '& h2': {
      color: 'white',
      margin: theme.spacing(1),
      fontSize: 20,
      fontWeight: 400,
    },
    '& p': {
      color: 'white',
      fontSize: 22,
    },
  },
  number: {
    fontSize: 48,
    fontWeight: 500,
    color: 'white',
    margin: theme.spacing(1),
  },
  shippedAmountMobile: {
    ...theme.homeStyle.section,
    width: '100vw',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    backgroundColor: '#fafafa',
    '& h2': {
      fontSize: 14,
    },
    '& p': {
      fontSize: 14,
      margin: 0,
      marginLeft: theme.spacing(1),
    },
  },
  highlight: {
    fontWeight: 400,
    fontSize: 32,
    color: theme.palette.primary.main,
  },
  about: {
    ...theme.homeStyle.section,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  innerAbout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: '#404040',
    '& p': {
      ...theme.homeStyle.bodyText,
      color: '#404040',
    },
  },
  featuresGrid: {
    marginTop: theme.spacing(5),
    '& p': {
      color: '#404040',
      margin: `${theme.spacing(2)}px 0 ${theme.spacing(6)}px`,
    },
  },
  moshiBox: {
    textAlign: 'left',
    '& img': {
      width: '100%',
      maxWidth: 300,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(4),
      '& img': {
        width: 250,
        height: 250,
      },
    },
  },
  moshiText: {
    padding: theme.spacing(3),
    '& h4': {
      color: '#404040',
      fontSize: 22,
      fontWeight: 500,
      margin: `${theme.spacing(3)}px 0`,
      ...theme.headerFont,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  rewardImg: {
    width: '100%',
    height: 300,
    objectFit: 'cover',
    borderRadius: 6,
  },
  readMoreList: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  rewards: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    '& h2': {
      ...theme.homeStyle.title,
      '& span': {
        color: 'inherit',
      },
    },
  },
  rewardsGrid: {
    maxWidth: 1200,
    textAlign: 'left',
    '& h4': {
      marginBottom: 0,
      width: '100%',
    },
    '& p': {
      ...theme.homeStyle.bodyText,
      color: '#828282',
    },
  },
  team: {
    ...theme.homeStyle.section,
  },
  teamCarousel: {
    marginBottom: theme.spacing(12),
    width: '100%',
    maxWidth: 1200,
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(6),
    },
  },
  trainingGrid: {
    width: '100%',
    maxWidth: 1000,
    fontSize: 14,
  },
  trainingImg: {
    maxWidth: 200,
    borderRadius: 6,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 300,
    },
  },
  trainingDesc: {
    fontSize: 16,
    fontWeight: 400,
  },
  readMoreLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  rewardBox: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}))

export async function getServerSideProps(context) {
  const translations = await serverSideTranslations(context.locale, [
    'common',
    'header',
    'footer',
    'pdpa',
    'about-us',
  ])

  // Courier logos are rendered only by the old design (?old). The default new
  // design never uses them, so don't make every visitor wait on
  // /api/get-couriers-logo (courier-info): a hang there used to hang this page.
  if (!('old' in context.query)) {
    return { props: { ...translations } }
  }

  try {
    const {
      data: { iconsPairs },
    } = await Axios.get(
      `${publicRuntimeConfig.siteDomain}/api/get-couriers-logo`
    )
    return { props: { ...translations, couriers: iconsPairs } }
  } catch (err) {
    return { props: { ...translations, couriers: [[]] } }
  }
}

const RewardBox = ({ reward, index, isExpanded, isMobile, classes, t }) => {
  const [isTruncated, setTruncated] = useState(true)

  if (!isMobile || isExpanded || index <= 2) {
    return (
      <Grid
        item
        container
        xs={12}
        sm={6}
        md={4}
        key={reward.title}
        direction="column"
        alignItems="center"
        className={classes.rewardBox}
      >
        <img
          src={`/static/img/about-us/rewards/${reward.img}`}
          alt={reward.desc}
          className={classes.rewardImg}
        />
        <h4>
          <img src="/static/img/about-us/rewards/cup.svg" /> {reward.title}
        </h4>
        <p>
          <LinesEllipsis
            text={reward.desc}
            maxLine={isTruncated ? 3 : 100}
            ellipsis={
              isTruncated ? (
                <span>
                  ...
                  <span className={classes.readMoreLink}>{t('read-more')}</span>
                </span>
              ) : (
                ''
              )
            }
            trimRight
            basedOn="letters"
            onClick={() => setTruncated(false)}
          />
          {!isTruncated && (
            <span
              className={classes.readMoreLink}
              onClick={() => setTruncated(true)}
            >
              {t('read-less')}
            </span>
          )}
        </p>
        {/* {isTruncated ? (
          <p>
            {reward.desc.slice(0, 132)}
            {reward.desc.length > 132 ? (
              <a
                onClick={() => setTruncated(false)}
                className={classes.readMoreList}
              >
                ...ดูเพิ่มเติม
              </a>
            ) : (
              ''
            )}
          </p>
        ) : (
          <p>
            {reward.desc}
            <a
              onClick={() => setTruncated(true)}
              className={classes.readMoreList}
            >
              <br />
              ซ่อน
            </a>
          </p>
        )} */}
      </Grid>
    )
  }
  return null
}

const Rewards = ({ classes, language, rewardsData, isMobile, t }) => {
  const [isExpanded, setExpanded] = useState(false)
  return (
    <div className={classes.rewards}>
      <h2>
        {language === 'th' ? (
          <>
            เราคว้า<span>รางวัล</span>มากมาย
          </>
        ) : (
          <>
            We won many <span>awards</span>.
          </>
        )}
      </h2>
      <Grid container className={classes.rewardsGrid}>
        {rewardsData.map((reward, index) => (
          <RewardBox
            reward={reward}
            index={index}
            isExpanded={isExpanded}
            key={index}
            isMobile={isMobile}
            classes={classes}
            t={t}
          />
        ))}
      </Grid>
      {isMobile ? (
        !isExpanded ? (
          <ButtonSp
            variant="outlined"
            fullWidth
            onClick={() => setExpanded(true)}
            key="more"
            style={{ height: 50 }}
          >
            ดูเพิ่มเติม
          </ButtonSp>
        ) : (
          <ButtonSp
            variant="outlined"
            fullWidth
            onClick={() => setExpanded(false)}
            key="less"
            style={{ height: 50 }}
          >
            ดูน้อยลง
          </ButtonSp>
        )
      ) : (
        ''
      )}
    </div>
  )
}

const AboutUsPageOld = ({ couriers = [[]] }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const classes = useStyles()

  const Router = useRouter()
  const language = Router.locale
  const { t } = useTranslation('about-us')

  const [totalParcel, setTotalParcel] = useState(getCookie('totalParcel') || 0)

  useEffect(() => {
    const getTotalParcel = async () => {
      try {
        const res = await Axios.get('/api/total-sending-parcel')
        const resData = res?.data
        const total_Parcel = resData?.totalParcel
        const expiredDate = dayjs().add(1, 'day').toDate()
        setCookie('totalParcel', total_Parcel, { expires: expiredDate })
        setTotalParcel(getCookie('totalParcel'))
      } catch (e) {
        console.log('error', e)
      }
    }

    if (!totalParcel) {
      getTotalParcel()
    }
  }, [])

  const renderHeroImage = () => (
    <>
      <div className={classes.heroImage}>
        <Container className={classes.heroContainer}>
          <div className={classes.heroText}>
            <h1>{t('about-us')}</h1>
            <h2 className={classes.makeShippingEasy}>“Make Shipping Easy”</h2>
          </div>
          <Hidden smDown implementation="css">
            <div className={classes.shippedAmount}>
              <div className={classes.shippedAmountText}>
                <h2>{t('number-parcel')}</h2>
                <Grid container direction="row" alignItems="center">
                  <CountUpSp
                    start={totalParcel * 0.8}
                    end={totalParcel}
                    duration={1}
                    className={classes.number}
                  />
                  <p>{t('items')}</p>
                </Grid>
              </div>
            </div>
          </Hidden>
        </Container>
      </div>
      <Hidden mdUp implementation="css">
        <Container className={classes.shippedAmountMobile}>
          <h2>{t('number-parcel')}</h2>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
          >
            <CountUpSp
              start={totalParcel * 0.8}
              end={totalParcel}
              duration={1}
              suffix={t('items')}
              className={classes.number}
              numberProps={{
                style: { color: theme.palette.primary.main },
              }}
            />
            <p> {t('items')}</p>
          </Grid>
        </Container>
      </Hidden>
    </>
  )

  const features = [
    [
      'about-us-feature-1.svg',
      <p>
        {language === 'th' ? (
          <>
            อันดับ
            <br />
            <span
              className={classes.highlight}
              style={{ color: theme.palette.primary.main }}
            >
              1
            </span>
            <br />
            {t('features.1-1')}
          </>
        ) : (
          <>
            Top
            <br />
            <span className={classes.highlight}>
              1<sup>st</sup>
            </span>
            <br />
            {t('features.1-1')}
          </>
        )}
      </p>,
    ],
    [
      'about-us-feature-2.svg',
      <p>
        {t('features.2-1')}
        <br />
        <span className={classes.highlight}>10+</span>
        <br />
        {t('features.2-2')}
      </p>,
    ],
    [
      'about-us-feature-3.svg',
      <p>
        {t('features.3-1')}
        <br />
        <span className={classes.highlight}>90+</span>
        <br />
        {t('features.3-2')}
      </p>,
    ],
  ]

  const renderAbout = () => (
    <div className={classes.about}>
      <Container className={classes.innerAbout}>
        <h2
          className={classes.title}
          style={{ marginBottom: theme.spacing(1) }}
        >
          {t('shippop.shippop-co')}
        </h2>
        <p style={{ textAlign: 'left' }}>{t('shippop.new-address')}</p>
        <p style={{ textAlign: 'left' }}>{t('shippop.detail')}</p>
        <Grid
          container
          alignItems={isMobile ? 'center' : 'flex-start'}
          className={classes.featuresGrid}
        >
          {features.map(([img, text], index) => (
            <Grid
              item
              container
              xs={12}
              sm={4}
              direction="column"
              key={index}
              alignItems="center"
            >
              <img
                src={`/static/img/about-us/${img}`}
                style={{ width: 180, height: 180 }}
                alt=""
              />
              {text}
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          direction="row"
          alignItems="center"
          className={classes.moshiBox}
        >
          <Grid
            item
            container
            xs={12}
            sm={6}
            direction="column"
            alignItems="center"
          >
            <img src="static/img/about-us/moshi-about-us-1.png" alt="moshi" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={classes.moshiText}>
              <h4>{t('vision.title')}</h4>
              <p>{t('vision.desc')}</p>
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row-reverse"
          alignItems="center"
          className={classes.moshiBox}
        >
          <Grid
            item
            container
            xs={12}
            sm={6}
            direction="column"
            alignItems="center"
          >
            <img src="static/img/about-us/moshi-about-us-2.png" alt="moshi" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={classes.moshiText}>
              <h4>{t('our-mission.title')}</h4>
              <p>{t('our-mission.desc')}</p>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  )

  const rewardsData = [
    {
      title: t('awards-detail.startup-of-the-year.title'),
      desc: t('awards-detail.startup-of-the-year.desc'),
      img: 'StartupOfTheYear.png',
    },
    {
      title: t('awards-detail.franchise-standard.title'),
      desc: t('awards-detail.franchise-standard.desc'),
      img: 'FranchiseStandard.png',
    },
    {
      title: t('awards-detail.award2021.title'),
      desc: t('awards-detail.award2021.desc'),
      img: 'award2021.png',
    },
    {
      title: t('awards-detail.ticta2020.title'),
      desc: t('awards-detail.ticta2020.desc'),
      img: 'ticta2020.png',
    },
    {
      title: t('awards-detail.red-cross.title'),
      desc: t('awards-detail.red-cross.desc'),
      img: 'redCross.jpg',
    },
    {
      title: t('awards-detail.national-inno.title'),
      desc: t('awards-detail.national-inno.desc'),
      img: 'NationalInnovation2020.jpg',
    },
    {
      title: t('awards-detail.log-tech.title'),
      desc: t('awards-detail.log-tech.desc'),
      img: 'LogTechAward2019.jpg',
    },
    {
      title: t('awards-detail.ticta.title'),
      desc: t('awards-detail.ticta.desc'),
      img: 'TICTA2019.jpg',
    },
    {
      title: t('awards-detail.apec.title'),
      desc: t('awards-detail.apec.desc'),
      img: 'APEC2018.jpg',
    },
    {
      title: t('awards-detail.gov-tech.title'),
      desc: t('awards-detail.gov-tech.desc'),
      img: 'GovTech2018.jpg',
    },
    {
      title: t('awards-detail.ais-startup.title'),
      desc: t('awards-detail.ais-startup.desc'),
      img: 'AisStartUp2017.jpg',
    },
    {
      title: t('awards-detail.tech-sauce.title'),
      desc: t('awards-detail.tech-sauce.desc'),
      img: 'Techsauce2017.jpg',
    },
    {
      title: t('awards-detail.startup-thailand.title'),
      desc: t('awards-detail.startup-thailand.desc'),
      img: 'StartupThailand.jpg',
    },
    {
      title: t('awards-detail.gsb-sme.title'),
      desc: t('awards-detail.gsb-sme.desc'),
      img: 'GSBSMEsStartup.jpg',
    },
    {
      title: t('awards-detail.rice-bowl.title'),
      desc: t('awards-detail.rice-bowl.desc'),
      img: 'RiceBowlStartupAwards2017.jpg',
    },
    {
      title: t('awards-detail.iso.title'),
      desc: t('awards-detail.iso.desc'),
      img: 'ISO9001_2015.jpg',
    },
    {
      title: t('awards-detail.best-small-franchise-2022.title'),
      desc: t('awards-detail.best-small-franchise-2022.desc'),
      img: 'Best_Small_Franchise_2022.jpg'
    },
    {
      title: t('awards-detail.apicta-2022.title'),
      desc: t('awards-detail.apicta-2022.desc'),
      img: 'APICTA_Awards_2022.jpg'
    },
    {
      title: t('awards-detail.best-small-franchise-2023.title'),
      desc: t('awards-detail.best-small-franchise-2023.desc'),
      img: 'Best_Small_Franchise_2023.jpg'
    },
  ]

  const trainings = [
    [t('training.university'), 'training-university.jpg'],
    [t('training.sme'), 'training-sme.jpg'],
    [t('training.online'), 'training-online.jpg'],
    [t('training.shop'), 'training-shop.jpg'],
  ]

  const renderTeam = () => (
    <div className={classes.team}>
      <h2 className={classes.title}>{t('our-teams')}</h2>
      <div className={classes.teamCarousel}>
        <CarouselSp2
          slidesPerPage={isDesktop ? 3 : isMobile ? 1 : 2}
          showArrows={!isMobile}
          showDots={isMobile}
        >
          {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
            <div key={n}>
              <img
                src={`/static/img/about-us/team/team${n}.jpg`}
                alt="team photo"
                style={{ borderRadius: 6 }}
              />
            </div>
          ))}
        </CarouselSp2>
      </div>
      <h2 className={classes.title}>{t('training-on-site')}</h2>
      {!isMobile ? (
        <Grid container className={classes.trainingGrid}>
          {trainings.map((training) => (
            <Grid
              container
              item
              xs={12}
              sm={6}
              md={3}
              direction="column"
              alignItems="center"
              key={training[0]}
            >
              <div>
                <img
                  src={`/static/img/about-us/training/${training[1]}`}
                  className={classes.trainingImg}
                />
              </div>
              <h4 className={classes.trainingDesc}>{training[0]}</h4>
            </Grid>
          ))}
        </Grid>
      ) : (
        <CarouselSp2 slidesPerPage={1} showDots>
          {trainings.map((training) => (
            <Grid
              container
              item
              xs={12}
              sm={6}
              md={3}
              direction="column"
              alignItems="center"
              key={training[0]}
            >
              <div>
                <img
                  src={`/static/img/about-us/training/${training[1]}`}
                  className={classes.trainingImg}
                />
              </div>
              <h4 className={classes.trainingDesc}>{training[0]}</h4>
            </Grid>
          ))}
        </CarouselSp2>
      )}
    </div>
  )

  console.info('couriers', couriers)

  return (
    <>
      <Layout
        title="เกี่ยวกับ SHIPPOP เราเป็น Startup ชั้นนำทางด้านขนส่ง การจัดส่งพัสดุ ทั่วไทย"
        keywords="shippop, บริษัท ชิปป๊อป จำกัด, ชิปป๊อป, บริการขนส่ง, ขนส่ง, ส่งของ"
        description="เราคือบริการออนไลน์ที่เชื่อมโยงขนส่งมาไว้ในระบบเดียว เรามุ่งหวังที่จะเชื่อมต่อขนส่งที่ดีที่สุดทั่วโลก ง่ายต่อการเชื่อมต่อและเลือกใช้บริการที่หลากหลาย ช่วยให้ผู้ประกอบการ SME พ่อค้าแม่ค้าออนไลน์หรือใครก็ตามที่ต้องการส่งของ"
      >
        <div className={classes.root}>
          {renderHeroImage()}
          {renderAbout()}
          <LazyLoad
            offset={1000}
            placeholder={<LazyloadPlaceholder />}
            once
            style={{ width: '100%' }}
          >
            <Rewards
              classes={classes}
              language={language}
              rewardsData={rewardsData}
              isMobile={isMobile}
              t={t}
            />
            <Couriers couriers={couriers} />
            {renderTeam()}
          </LazyLoad>
        </div>
      </Layout>
    </>
  )
}

// ?new → new-design variant (new chrome, same content); otherwise the old
// page renders unchanged. Wrapper keeps hook order stable across both paths
// (each branch is its own component, so neither shares the other's hooks).
const AboutUsPage = (props) => {
  const { query } = useRouter()
  if ('old' in query) return <AboutUsPageOld {...props} />
  return <AboutNew {...props} />
}

export default AboutUsPage
